import Link from "next/link";

const CategoryBanner = ({ categoryId, categoryDetails, totalCourses }) => {

  console.log("Category menu id ", JSON.stringify(categoryId))
  console.log("Category menu object ", JSON.stringify(categoryDetails))

  return (
    <>
      <div className="rbt-banner-content-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <ul className="page-list">
                <li className="rbt-breadcrumb-item">
                  <Link href="/">Home</Link>
                </li>
                <li>
                  <div className="icon-right">
                    <i className="feather-chevron-right"></i>
                  </div>
                </li>
                <li className="rbt-breadcrumb-item active">
                  {categoryDetails && categoryDetails.name
                    ? categoryDetails.name
                    : "All Courses"}
                </li>
              </ul>
              <div className=" title-wrapper">
                <h1 className="title mb--0">
                  {" "}
                  {categoryDetails && categoryDetails.name
                    ? categoryDetails.name
                    : "All Courses"}
                </h1>
                <Link href="#" className="rbt-badge-2">
                  <div className="image">🎉</div>
                  {totalCourses} <span style={{ marginLeft: 10 }}></span>Courses
                </Link>
              </div>
              <p className="description">
                {categoryDetails && categoryDetails.description
                  ? categoryDetails.description
                  : "\"The Best Way To Predict The Future is to Acquire The Appropriate Skills To Create It\". Search for your course and Get Started."}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CategoryBanner;
